import { Link, Typography } from '@mui/material';

import { PageWrapper } from '@/components/PageWrapper';

export function Imprint() {
  return (
    <PageWrapper>
      <Typography>
        Das Impressum finden Sie auf der{' '}
        <Link
          fontWeight={500}
          href="https://www.trafficon.eu/impressum/"
          rel="noopener noreferrer"
          sx={{ color: 'text.primary' }}
          target="_blank"
        >
          Webseite von Trafficon
        </Link>
        .
      </Typography>
    </PageWrapper>
  );
}
